import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 6.99h3V14h2V6.99h3L9 3zM14 10v7.01h-3L15 21l4-3.99h-3V10z"
}), 'ImportExportTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ImportExportTwoTone.js
// module id = 4229
// module chunks = 2